import React from "react";
import { View, Text } from "@/styles/reactnative";
import { COLORS } from "@app/constants";

interface IProps {
  data?: number;
}
const CBadge = ({ data }: IProps) => {
  return (
    <View
      style={{
        background: COLORS.primaryDark,
        borderRadius: 3,
        justifyContent: "center",
        alignItems: "center",
        alignSelf: "center",
        paddingBlock: 2,
        paddingInline: 4,
        marginLeft: 5,
      }}
    >
      <Text style={{ fontSize: 12 }}>{data}x</Text>
    </View>
  );
};

export default React.memo(CBadge);
